(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ccp-moft]';
  var instances = new WeakMap();

  function text(value) {
    return String(value == null ? '' : value).trim();
  }

  function normalized(value) {
    return text(value).toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function canonicalColor(value) {
    var valueKey = normalized(value);
    var aliases = {
      'taupe': 'taupe', 'greige': 'taupe', 'グレージュ': 'taupe', 'トープ': 'taupe',
      'black': 'black', 'ブラック': 'black', '黒': 'black',
      'beige': 'beige', 'ベージュ': 'beige',
      'light pink': 'light pink', 'ライトピンク': 'light pink', '淡いピンク': 'light pink',
      'mocha': 'mocha', 'モカ': 'mocha',
      'orange': 'orange', 'オレンジ': 'orange'
    };
    return aliases[valueKey] || valueKey;
  }

  function productOptions(product) {
    if (!product || !Array.isArray(product.options)) return [];
    return product.options.map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function variantOption(variant, index) {
    if (!variant) return '';
    if (Array.isArray(variant.options)) return variant.options[index] || '';
    return variant['option' + (index + 1)] || '';
  }

  function absoluteImageUrl(url) {
    url = text(url);
    return url.indexOf('//') === 0 ? window.location.protocol + url : url;
  }

  function variantImage(variant, product, fallback) {
    var image = variant && (variant.featured_image || (variant.featured_media && variant.featured_media.preview_image));
    if (image) return absoluteImageUrl(typeof image === 'string' ? image : (image.src || image.url || ''));
    var featured = product && product.featured_image;
    if (featured) return absoluteImageUrl(typeof featured === 'string' ? featured : (featured.src || featured.url || ''));
    return absoluteImageUrl(fallback || '');
  }

  function parseAmount(value) {
    var amount = Number(String(value || '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(amount) && amount > 0 ? Math.round(amount * 100) : 0;
  }

  function productUrl(product, variant) {
    if (!product || !product.handle) return '#';
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return root + 'products/' + product.handle + (variant && variant.id ? '?variant=' + variant.id : '');
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      var formatted = window.theme.formatMoney(cents, window.theme.moneyFormat);
      if (typeof formatted === 'string' && formatted.indexOf('<') >= 0) {
        var decoder = document.createElement('div');
        decoder.innerHTML = formatted;
        return text(decoder.textContent);
      }
      return formatted;
    }
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (_error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function optionIndexByName(product, patterns) {
    return productOptions(product).findIndex(function (name) {
      var key = normalized(name);
      return patterns.some(function (pattern) { return key.indexOf(pattern) >= 0; });
    });
  }

  function colorIndex(product, targetColor) {
    var names = productOptions(product);
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var target = canonicalColor(targetColor);
    if (target) {
      var valueIndex = names.findIndex(function (_name, index) {
        return variants.some(function (variant) {
          return canonicalColor(variantOption(variant, index)) === target;
        });
      });
      if (valueIndex >= 0) return valueIndex;
    }
    return optionIndexByName(product, ['color', 'colour', 'カラー', '色', 'couleur', 'farbe', 'colore', '颜色', '顏色']);
  }

  function modelIndex(product) {
    return optionIndexByName(product, [
      'model', 'device', 'phone', 'size', 'phone model', 'phone size',
      '機種', '型号', '型號', 'モデル', 'サイズ', '尺寸'
    ]);
  }

  function unique(values) {
    return values.filter(function (value, index, list) {
      return value && list.indexOf(value) === index;
    });
  }

  function chooseVariant(product, targetColor, targetModel, preferredTitle, selections) {
    if (!product || !Array.isArray(product.variants)) return null;
    var cIndex = colorIndex(product, targetColor);
    var mIndex = modelIndex(product);
    var preferred = normalized(preferredTitle);
    var chosen = selections || {};

    function matches(variant, availableOnly) {
      if (availableOnly && !variant.available) return false;
      if (targetColor && cIndex >= 0 && canonicalColor(variantOption(variant, cIndex)) !== canonicalColor(targetColor)) return false;
      if (targetModel && mIndex >= 0 && normalized(variantOption(variant, mIndex)) !== normalized(targetModel)) return false;
      return Object.keys(chosen).every(function (index) {
        return variantOption(variant, Number(index)) === chosen[index];
      });
    }

    var exactPreferred = product.variants.find(function (variant) {
      return preferred && normalized(variant.public_title || variant.title) === preferred && matches(variant, true);
    });
    if (exactPreferred) return exactPreferred;

    var exact = product.variants.find(function (variant) { return matches(variant, true); });
    if (exact) return exact;

    return product.variants.find(function (variant) { return matches(variant, false); }) || null;
  }

  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }

  function MoftShowcase(root) {
    this.root = root;
    this.data = this.readData();
    this.groups = this.data.groups || [];
    this.modelOverrides = this.data.modelOverrides || [];
    this.productCache = {};
    this.activeGroup = this.groups[0] || null;
    this.activeModel = root.dataset.defaultModel || '';
    this.currentSlots = [];
    this.completeProduct = null;
    this.completeVariant = null;
    this.dialogSlot = null;
    this.dialogSelections = {};
    this.cacheProducts();
    this.mountAfterStyleSets();
    this.bind();
    this.setDefaultModel();
    this.render();
    root.dataset.ccpMoftInitialized = 'true';
  }

  MoftShowcase.prototype.readData = function () {
    var script = this.root.querySelector('[data-moft-data]');
    try { return JSON.parse(script ? script.textContent : '{}'); }
    catch (error) {
      console.error('CCP MOFT showcase data could not be parsed.', error);
      return { groups: [], modelOverrides: [] };
    }
  };

  MoftShowcase.prototype.cacheProducts = function () {
    var self = this;
    function cache(product) {
      if (product && product.handle) self.productCache[product.handle] = product;
    }
    this.groups.forEach(function (group) {
      cache(group.completeProduct);
      (group.products || []).forEach(function (slot) { cache(slot.product); });
    });
    this.modelOverrides.forEach(function (override) { cache(override.completeProduct); });
  };

  MoftShowcase.prototype.mountAfterStyleSets = function () {
    var anchor = document.querySelector('[data-ccp-moft-anchor]');
    var target = anchor || document.querySelector('.ccp-style-sets');
    if (!this.sectionWrapper) this.sectionWrapper = this.root.closest('.shopify-section');
    if (target && this.root !== target.nextElementSibling && !this.root.contains(target)) {
      target.insertAdjacentElement('afterend', this.root);
    }
  };

  MoftShowcase.prototype.returnToOrigin = function () {
    if (!this.sectionWrapper || !this.sectionWrapper.isConnected) return;
    var assetScript = this.sectionWrapper.querySelector('script[src*="ccp-moft-showcase"]');
    this.sectionWrapper.insertBefore(this.root, assetScript || null);
  };

  MoftShowcase.prototype.setDefaultModel = function () {
    var select = this.root.querySelector('[data-moft-model]');
    if (!select) return;
    var requested = normalized(this.activeModel);
    var match = Array.prototype.slice.call(select.options).find(function (option) {
      return normalized(option.value) === requested;
    });
    if (match) select.value = match.value;
    this.activeModel = select.value || this.activeModel;
  };

  MoftShowcase.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var colorButton = event.target.closest('[data-moft-color]');
      var addButton = event.target.closest('[data-moft-card-add]');
      var quickButton = event.target.closest('[data-moft-quick]');
      if (colorButton) self.setColor(colorButton.dataset.moftColor);
      if (addButton) self.addSlot(Number(addButton.dataset.moftCardAdd), addButton);
      if (quickButton) self.openDialog(Number(quickButton.dataset.moftQuick));
      if (event.target.closest('[data-moft-add-set]')) self.addCompleteSet(event.target.closest('[data-moft-add-set]'));
      if (event.target.closest('[data-moft-dialog-close]')) self.closeDialog();
      if (event.target.closest('[data-moft-dialog-add]')) self.addDialogVariant(event.target.closest('[data-moft-dialog-add]'));
      if (event.target.closest('[data-moft-prev]')) self.scrollProducts(-1);
      if (event.target.closest('[data-moft-next]')) self.scrollProducts(1);
    });

    var modelSelect = this.root.querySelector('[data-moft-model]');
    if (modelSelect) modelSelect.addEventListener('change', function () {
      self.activeModel = modelSelect.value;
      self.render();
    });

    var dialog = this.root.querySelector('[data-moft-dialog]');
    if (dialog) dialog.addEventListener('click', function (event) {
      if (event.target === dialog) self.closeDialog();
    });
  };

  MoftShowcase.prototype.setColor = function (key) {
    var next = this.groups.find(function (group) { return group.key === key; });
    if (!next || next === this.activeGroup) return;
    this.activeGroup = next;
    this.render();
  };

  MoftShowcase.prototype.getOverride = function () {
    var self = this;
    return this.modelOverrides.find(function (override) {
      return override.colorKey === self.activeGroup.key && normalized(override.model) === normalized(self.activeModel);
    }) || null;
  };

  MoftShowcase.prototype.slotsForGroup = function () {
    var byType = {};
    (this.activeGroup.products || []).forEach(function (slot) {
      var typeKey = normalized(slot.slotType || 'accessory');
      byType[typeKey] = slot;
    });
    return Object.keys(byType).map(function (key) { return byType[key]; });
  };

  MoftShowcase.prototype.render = function () {
    if (!this.activeGroup) return;
    this.root.style.setProperty('--ccp-moft-bg', this.activeGroup.background || '#eee9e3');
    this.root.style.setProperty('--ccp-moft-text', this.activeGroup.text || '#171717');
    this.renderControls();
    this.renderVisual();
    this.renderProducts();
    this.renderCompleteSet();
  };

  MoftShowcase.prototype.renderControls = function () {
    var self = this;
    this.root.querySelectorAll('[data-moft-color]').forEach(function (button) {
      var active = button.dataset.moftColor === self.activeGroup.key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  MoftShowcase.prototype.renderVisual = function () {
    var visual = this.root.querySelector('[data-moft-visual]');
    var image = this.root.querySelector('[data-moft-model-image]');
    var placeholder = this.root.querySelector('[data-moft-image-placeholder]');
    var bundle = this.root.querySelector('[data-moft-bundle-image]');
    var override = this.getOverride();
    var nextSrc = absoluteImageUrl(override && override.image ? override.image : this.activeGroup.modelImage);

    if (nextSrc && !image) {
      image = document.createElement('img');
      image.setAttribute('data-moft-model-image', '');
      image.width = 1600;
      image.height = 1200;
      image.loading = 'lazy';
      visual.insertBefore(image, visual.firstChild);
    }
    if (image && nextSrc && image.dataset.moftCurrentSrc !== nextSrc) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = nextSrc;
      image.dataset.moftCurrentSrc = nextSrc;
      image.alt = this.activeGroup.name || '';
      visual.classList.remove('is-changing');
      void visual.offsetWidth;
      visual.classList.add('is-changing');
    }
    if (image) image.hidden = !nextSrc;
    if (placeholder) placeholder.hidden = Boolean(nextSrc);

    if (bundle) {
      if (this.activeGroup.bundleImage) {
        bundle.src = absoluteImageUrl(this.activeGroup.bundleImage);
        bundle.alt = this.activeGroup.name ? this.activeGroup.name + ' complete set' : 'Complete set';
        bundle.hidden = false;
      } else {
        bundle.hidden = true;
        bundle.removeAttribute('src');
        bundle.alt = '';
      }
    }
  };

  MoftShowcase.prototype.renderProducts = function () {
    var self = this;
    var holder = this.root.querySelector('[data-moft-products]');
    if (!holder) return;
    holder.innerHTML = '';
    this.currentSlots = this.slotsForGroup().map(function (slot) {
      var product = slot.product;
      var slotModel = normalized(slot.slotType).indexOf('phone case') >= 0 ? self.activeModel : '';
      var variant = chooseVariant(product, self.activeGroup.productColor, slotModel, slot.variantTitle);
      slot._variant = variant;
      return slot;
    });

    this.currentSlots.forEach(function (slot, index) {
      var product = slot.product;
      if (!product) return;
      var variant = slot._variant;
      var card = element('article', 'ccp-moft__product-card is-changing');
      var media = element('button', 'ccp-moft__product-media');
      media.type = 'button';
      media.dataset.moftQuick = index;
      var image = document.createElement('img');
      image.src = variantImage(variant, product, slot.fallbackImage);
      image.alt = slot.nameOverride || product.title || slot.slotType || '';
      image.width = 900;
      image.height = 900;
      image.loading = 'lazy';
      media.appendChild(image);
      card.appendChild(media);

      var body = element('div', 'ccp-moft__product-body');
      body.appendChild(element('p', 'ccp-moft__product-type', slot.slotType || 'Accessory'));
      var title = element('button', 'ccp-moft__product-title', slot.nameOverride || product.title || slot.slotType);
      title.type = 'button';
      title.dataset.moftQuick = index;
      body.appendChild(title);
      if (slot.description) body.appendChild(element('p', 'ccp-moft__product-description', slot.description));
      body.appendChild(element('p', 'ccp-moft__product-price', variant ? formatMoney(variant.price) : self.root.dataset.unavailableText));
      var add = element('button', 'ccp-moft__button ccp-moft__product-add', self.root.dataset.addText || 'Add To Cart');
      add.type = 'button';
      add.dataset.moftCardAdd = index;
      add.disabled = !variant || !variant.available;
      body.appendChild(add);
      card.appendChild(body);
      holder.appendChild(card);
    });
  };

  MoftShowcase.prototype.renderCompleteSet = function () {
    var override = this.getOverride();
    var product = override && override.completeProduct ? override.completeProduct : this.activeGroup.completeProduct;
    var preferred = override && override.variantTitle ? override.variantTitle : '';
    var variant = chooseVariant(product, this.activeGroup.productColor, this.activeModel, preferred);
    this.completeProduct = product;
    this.completeVariant = variant;

    var slotsTotal = this.currentSlots.reduce(function (sum, slot) {
      return sum + (slot.include !== false && slot._variant ? Number(slot._variant.price || 0) : 0);
    }, 0);
    var manual = parseAmount(override && override.completePrice ? override.completePrice : this.activeGroup.completePrice);
    var price = manual || (variant ? Number(variant.price || 0) : slotsTotal);
    var compare = parseAmount(this.activeGroup.comparePrice) || (variant ? Number(variant.compare_at_price || 0) : slotsTotal);
    var manualSave = parseAmount(this.activeGroup.saveAmount);
    if (compare <= price) compare = manualSave ? price + manualSave : 0;
    var save = manualSave || Math.max(0, compare - price);

    var priceNode = this.root.querySelector('[data-moft-price]');
    var compareNode = this.root.querySelector('[data-moft-compare-price]');
    var saveNode = this.root.querySelector('[data-moft-save]');
    if (priceNode) priceNode.textContent = price ? formatMoney(price) : '—';
    if (compareNode) {
      compareNode.hidden = !compare;
      compareNode.textContent = compare ? formatMoney(compare) : '';
    }
    if (saveNode) {
      saveNode.hidden = !save;
      saveNode.textContent = save ? 'Save ' + formatMoney(save) : '';
    }

    var pick = this.root.querySelector('[data-moft-pick]');
    if (pick) {
      var link = (override && override.completeLink) || this.activeGroup.completeLink ||
        (product ? productUrl(product, variant) : this.root.dataset.pickFallback) || '#';
      pick.href = link;
    }
  };

  MoftShowcase.prototype.cartAdd = async function (items) {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!response.ok) {
      var payload = await response.json().catch(function () { return {}; });
      throw new Error(payload.description || this.root.dataset.errorText || 'Unable to add this item.');
    }
    var payload = await response.json();
    this.refreshThemeCart();
    return payload;
  };

  MoftShowcase.prototype.refreshThemeCart = function () {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:drawer:update', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
  };

  MoftShowcase.prototype.addSlot = async function (index, button) {
    var slot = this.currentSlots[index];
    if (!slot || !slot._variant || !slot._variant.available) return;
    var status = this.root.querySelector('[data-moft-status]');
    var original = button.textContent;
    button.disabled = true;
    button.textContent = this.root.dataset.addingText || 'Adding…';
    try {
      await this.cartAdd([{ id: Number(slot._variant.id), quantity: 1 }]);
      button.textContent = this.root.dataset.addedText || 'Added';
      if (status) status.textContent = (slot.nameOverride || slot.product.title) + ' added to cart.';
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = original;
      }, 1400);
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      if (status) status.textContent = error.message || this.root.dataset.errorText;
    }
  };

  MoftShowcase.prototype.addCompleteSet = async function (button) {
    var items;
    if (this.completeVariant && this.completeVariant.available) {
      items = [{ id: Number(this.completeVariant.id), quantity: 1 }];
    } else {
      items = this.currentSlots.filter(function (slot) {
        return slot.include !== false && slot._variant && slot._variant.available;
      }).map(function (slot) {
        return { id: Number(slot._variant.id), quantity: 1, properties: { '_CCP Set': 'Complete Set' } };
      });
    }
    var status = this.root.querySelector('[data-moft-status]');
    if (!items.length) {
      if (status) status.textContent = this.root.dataset.unavailableText;
      return;
    }
    var original = button.textContent;
    button.disabled = true;
    button.textContent = this.root.dataset.addingText || 'Adding…';
    try {
      await this.cartAdd(items);
      button.textContent = this.root.dataset.addedText || 'Added';
      if (status) status.textContent = 'Complete set added to cart.';
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = original;
      }, 1400);
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      if (status) status.textContent = error.message || this.root.dataset.errorText;
    }
  };

  MoftShowcase.prototype.openDialog = function (index) {
    var slot = this.currentSlots[index];
    if (!slot || !slot.product) return;
    this.dialogSlot = slot;
    this.dialogSelections = {};
    var dialog = this.root.querySelector('[data-moft-dialog]');
    var product = slot.product;
    var variant = slot._variant;
    var image = this.root.querySelector('[data-moft-dialog-image]');
    var title = this.root.querySelector('[data-moft-dialog-title]');
    var type = this.root.querySelector('[data-moft-dialog-type]');
    var link = this.root.querySelector('[data-moft-dialog-link]');
    if (image) {
      image.src = variantImage(variant, product, slot.fallbackImage);
      image.alt = slot.nameOverride || product.title || '';
    }
    if (title) title.textContent = slot.nameOverride || product.title || slot.slotType;
    if (type) type.textContent = slot.slotType || 'Accessory';
    if (link) link.href = slot.link || productUrl(product, variant);
    this.buildDialogOptions(variant);
    this.updateDialogVariant();
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    else if (dialog) dialog.setAttribute('open', '');
  };

  MoftShowcase.prototype.buildDialogOptions = function (variant) {
    var self = this;
    var holder = this.root.querySelector('[data-moft-dialog-options]');
    var product = this.dialogSlot.product;
    holder.innerHTML = '';
    productOptions(product).forEach(function (name, index) {
      var values = unique(product.variants.map(function (item) { return variantOption(item, index); }));
      if (!values.length || (values.length === 1 && values[0] === 'Default Title')) return;
      var wrap = element('div', 'ccp-moft__dialog-option');
      var label = element('label', '', name);
      var select = document.createElement('select');
      var selectId = 'ccp-moft-option-' + self.root.dataset.sectionId + '-' + index;
      label.htmlFor = selectId;
      select.id = selectId;
      values.forEach(function (value) {
        var option = element('option', '', value);
        option.value = value;
        select.appendChild(option);
      });
      var initial = variantOption(variant, index) || values[0];
      select.value = initial;
      self.dialogSelections[index] = initial;
      select.addEventListener('change', function () {
        self.dialogSelections[index] = select.value;
        self.updateDialogVariant();
      });
      wrap.appendChild(label);
      wrap.appendChild(select);
      holder.appendChild(wrap);
    });
  };

  MoftShowcase.prototype.updateDialogVariant = function () {
    if (!this.dialogSlot) return;
    var product = this.dialogSlot.product;
    var variant = chooseVariant(product, '', '', '', this.dialogSelections);
    this.dialogSlot._dialogVariant = variant;
    var price = this.root.querySelector('[data-moft-dialog-price]');
    var image = this.root.querySelector('[data-moft-dialog-image]');
    var add = this.root.querySelector('[data-moft-dialog-add]');
    var link = this.root.querySelector('[data-moft-dialog-link]');
    if (price) price.textContent = variant ? formatMoney(variant.price) : this.root.dataset.unavailableText;
    if (image && variant) image.src = variantImage(variant, product, this.dialogSlot.fallbackImage);
    if (add) add.disabled = !variant || !variant.available;
    if (link) link.href = this.dialogSlot.link || productUrl(product, variant);
  };

  MoftShowcase.prototype.addDialogVariant = async function (button) {
    var variant = this.dialogSlot && this.dialogSlot._dialogVariant;
    if (!variant || !variant.available) return;
    var status = this.root.querySelector('[data-moft-dialog-status]');
    var original = button.textContent;
    button.disabled = true;
    button.textContent = this.root.dataset.addingText || 'Adding…';
    try {
      await this.cartAdd([{ id: Number(variant.id), quantity: 1 }]);
      button.textContent = this.root.dataset.addedText || 'Added';
      if (status) status.textContent = 'Added to cart.';
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = original;
      }, 1400);
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      if (status) status.textContent = error.message || this.root.dataset.errorText;
    }
  };

  MoftShowcase.prototype.closeDialog = function () {
    var dialog = this.root.querySelector('[data-moft-dialog]');
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  MoftShowcase.prototype.scrollProducts = function (direction) {
    var holder = this.root.querySelector('[data-moft-products]');
    if (holder) holder.scrollBy({ left: holder.clientWidth * .8 * direction, behavior: 'smooth' });
  };

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (!instances.has(root)) instances.set(root, new MoftShowcase(root));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function () {
    init(document);
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.mountAfterStyleSets();
    });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      var instance = instances.get(root);
      if (!instance) return;
      if (event.target === instance.sectionWrapper) {
        root.remove();
      } else if (event.target.contains(root)) {
        instance.returnToOrigin();
      }
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target && event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    var instance = root && instances.get(root);
    if (!instance) return;
    var button = root.querySelector('[data-block-id="' + event.detail.blockId + '"]');
    if (button) instance.setColor(button.dataset.moftColor);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target && event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? event.target
      : (event.target && event.target.querySelector ? event.target.querySelector(ROOT_SELECTOR) : null);
    if (!root && event.detail && event.detail.sectionId) {
      root = Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR)).find(function (candidate) {
        return candidate.dataset.sectionId === event.detail.sectionId;
      }) || null;
    }
    if (!root) return;
    var instance = instances.get(root);
    if (instance) instance.mountAfterStyleSets();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
